import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { useLocalization } from '~/composables/_next/useLocalization';
import useRightPath from './useRightPath';
import { isSeoActivatedForLanguage, DUMBSLUG_PREFIX } from '~/i18n.config';
import { z } from 'zod';
import { acceptLanguage } from '~/i18n.config';
var useLegacySeoMeta = function useLegacySeoMeta() {
  var _useRightPath = useRightPath(),
    getDomain = _useRightPath.getDomain,
    getCanonicalUrl = _useRightPath.getCanonicalUrl;
  var route = useRoute();
  var _useLocalization = useLocalization(),
    defaultLocale = _useLocalization.defaultLocale;
  var data = useState('seo-meta-data', function () {
    return null;
  });
  var _useNuxt2App = useNuxt2App(),
    app = _useNuxt2App.app,
    $sentry = _useNuxt2App.$sentry;
  var hasSocialMeta = function hasSocialMeta() {
    var _data$value;
    return ((_data$value = data.value) === null || _data$value === void 0 ? void 0 : _data$value.socialMeta) && Object.values(data.value.socialMeta).length;
  };
  var _appendPagination = function _appendPagination(title) {
    var page = Number(route === null || route === void 0 ? void 0 : route.query.page);
    if (page > 1) {
      return "".concat(title, " - Page ").concat(page);
    }
    return title;
  };
  var setMeta = function setMeta(tags) {
    data.value = tags;
  };
  var getPaginationMetaLinks = function getPaginationMetaLinks() {
    var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var linkData = [];
    var urlQuery = _objectSpread({}, route.query);
    var page = Number(urlQuery.page || 1);
    urlQuery === null || urlQuery === void 0 ? true : delete urlQuery.page;
    var url = getCanonicalUrl().split('?')[0];
    if (page > 1) {
      var queryParams = _objectSpread({}, urlQuery);
      if (page > 2) queryParams.page = page - 1;
      var href = url;
      if (Object.keys(queryParams).length) href += "?".concat(new URLSearchParams(queryParams).toString());
      linkData.push({
        rel: 'prev',
        href: cleanUrlParams(href)
      });
    }
    if (page < total) {
      var _queryParams = _objectSpread(_objectSpread({}, urlQuery), {
        page: page + 1
      });
      var _href = "".concat(url, "?").concat(new URLSearchParams(_queryParams).toString());
      linkData.push({
        rel: 'next',
        href: cleanUrlParams(_href)
      });
    }
    return linkData;
  };
  var QUERY_PARAMETERS_TO_ALWAYS_KEEP = ['page', 'type', 'letter', 'sort'];

  /**
   * Remove query parameters
   * @param query query to remove parameters from
   * @param keepParams array of parameters to keep
   * @returns cleaned query parameters
   */
  function cleanQuery(query) {
    var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    QUERY_PARAMETERS_TO_ALWAYS_KEEP.forEach(function (p) {
      return keepParams.add(p);
    }); // always keep these parameters

    var resQuery = {};
    Object.keys(query).forEach(function (key) {
      if (keepParams.has(key)) {
        resQuery[key] = query[key];
      }
    });
    return resQuery;
  }

  /**
   * Remove url parameters
   * @param url url to remove parameters from
   * @param keepParams array of parameters to keep
   * @returns cleaned url
   */
  function cleanUrlParams(url) {
    var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    QUERY_PARAMETERS_TO_ALWAYS_KEEP.forEach(function (p) {
      return keepParams.add(p);
    }); // always keep these parameters

    try {
      var parsedUrl = new URL(url);
      var paramsToDelete = [];
      parsedUrl.searchParams.forEach(function (_, key) {
        if (!keepParams.has(key)) {
          paramsToDelete.push(key);
        }
      });
      paramsToDelete.forEach(function (key) {
        return parsedUrl.searchParams.delete(key);
      });
      return parsedUrl.toString();
    } catch (error) {
      $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(new Error('Error parsing URL'), {
        url: url
      });
      return url; // Return the original URL if parsing fails
    }
  }

  /**
   * Get all option attributes (which are used as query parameters) from facets
   * @param facets
   * @returns list of query attributes
   */
  function getOptionAttributeNamesFromFacets(facets) {
    var _facets$flatMap$flatM, _facets$flatMap, _facets$flatMap$flatM2, _facets$flatMap$flatM3;
    var facetAttrs = (_facets$flatMap$flatM = facets === null || facets === void 0 ? void 0 : (_facets$flatMap = facets.flatMap(function (facet) {
      return facet.subfacets || facet;
    })) === null || _facets$flatMap === void 0 ? void 0 : (_facets$flatMap$flatM2 = _facets$flatMap.flatMap(function (facet) {
      return facet && Array.isArray(facet.options) ? facet.options : [];
    })) === null || _facets$flatMap$flatM2 === void 0 ? void 0 : (_facets$flatMap$flatM3 = _facets$flatMap$flatM2.map(function (option) {
      return option.attrName;
    })) === null || _facets$flatMap$flatM3 === void 0 ? void 0 : _facets$flatMap$flatM3.filter(Boolean)) !== null && _facets$flatMap$flatM !== void 0 ? _facets$flatMap$flatM : [];
    return _toConsumableArray(new Set(facetAttrs));
  }
  var getMeta = function getMeta() {
    var _data$value2, _data$value$ogTitle, _data$value3, _data$value4, _data$value5, _data$value6, _data$value6$keywords, _data$value7, _data$value8, _data$value9, _data$value0, _data$value1, _data$value10, _data$value11, _route$query, _data$value13;
    var metaData = {
      title: _appendPagination(((_data$value2 = data.value) === null || _data$value2 === void 0 ? void 0 : _data$value2.title) || 'Aroma-Zone'),
      ogTitle: (_data$value$ogTitle = (_data$value3 = data.value) === null || _data$value3 === void 0 ? void 0 : _data$value3.ogTitle) !== null && _data$value$ogTitle !== void 0 ? _data$value$ogTitle : (_data$value4 = data.value) === null || _data$value4 === void 0 ? void 0 : _data$value4.title,
      meta: [],
      link: []
    };
    metaData.meta.push({
      property: 'og:title',
      content: metaData.ogTitle
    });
    metaData.meta.push({
      name: 'description',
      content: ((_data$value5 = data.value) === null || _data$value5 === void 0 ? void 0 : _data$value5.description) || ''
    });
    if ((_data$value6 = data.value) !== null && _data$value6 !== void 0 && (_data$value6$keywords = _data$value6.keywords) !== null && _data$value6$keywords !== void 0 && _data$value6$keywords.length) {
      metaData.meta.push({
        name: 'keywords',
        content: data.value.keywords
      });
    }
    if (((_data$value7 = data.value) === null || _data$value7 === void 0 ? void 0 : _data$value7.no_follow) === true || ((_data$value8 = data.value) === null || _data$value8 === void 0 ? void 0 : _data$value8.no_index) === true) {
      var content = [];
      if (data.value.no_follow === true) {
        content.push('nofollow');
      }
      if (data.value.no_index === true) {
        content.push('noindex');
      }
      metaData.meta.push({
        name: 'robots',
        content: content
      });
    }
    if ((data === null || data === void 0 ? void 0 : (_data$value9 = data.value) === null || _data$value9 === void 0 ? void 0 : _data$value9.noFollow) === true || (data === null || data === void 0 ? void 0 : (_data$value0 = data.value) === null || _data$value0 === void 0 ? void 0 : _data$value0.noIndex) === true) {
      var _content = [];
      if (data.value.noFollow === true) {
        _content.push('nofollow');
      }
      if (data.value.noIndex === true) {
        _content.push('noindex');
      }
      metaData.meta.push({
        name: 'robots',
        content: _content
      });
    }
    if (((_data$value1 = data.value) === null || _data$value1 === void 0 ? void 0 : _data$value1.largePreview) === true) {
      metaData.meta.push({
        name: 'robots',
        content: 'max-image-preview:large'
      });
    }
    if ((_data$value10 = data.value) !== null && _data$value10 !== void 0 && _data$value10.canonicalUrl || (_data$value11 = data.value) !== null && _data$value11 !== void 0 && _data$value11.canonical) {
      var _data$value12;
      metaData.link.push({
        rel: 'canonical',
        href: ((_data$value12 = data.value) === null || _data$value12 === void 0 ? void 0 : _data$value12.canonicalUrl) || data.value.canonical
      });
    }
    var pageSchema = z.coerce.number().int().gte(1);
    var parsedPage = pageSchema.safeParse((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.page);
    var isPagination = parsedPage.success && parsedPage.data > 1;
    if (!isPagination && (_data$value13 = data.value) !== null && _data$value13 !== void 0 && _data$value13.slug && Object.keys(data.value.slug).length > 0) {
      var metaConfig = function metaConfig(id, lang, slug) {
        var _data$value$hreflangO, _data$value$hreflangO2, _data$value$hreflangO3;
        var getPathPrefix = function getPathPrefix() {
          var _Object$values;
          var routeParam = (_Object$values = Object.values(route.params)) === null || _Object$values === void 0 ? void 0 : _Object$values[0];
          var localizedPath = app.switchLocalePath(lang);
          var cleanedPath = localizedPath.replace(routeParam, '$[param]');
          return cleanedPath;
        };
        var getSlug = function getSlug() {
          var _slug$split;
          if (slug === '/') {
            return '';
          }
          var cleanedSlug = (_slug$split = slug.split('?')) === null || _slug$split === void 0 ? void 0 : _slug$split[0];
          return cleanedSlug;
        };
        var pathPrefix = (_data$value$hreflangO = (_data$value$hreflangO2 = data.value.hreflangOverrides) === null || _data$value$hreflangO2 === void 0 ? void 0 : (_data$value$hreflangO3 = _data$value$hreflangO2[lang]) === null || _data$value$hreflangO3 === void 0 ? void 0 : _data$value$hreflangO3.pathPrefix) !== null && _data$value$hreflangO !== void 0 ? _data$value$hreflangO : getPathPrefix();
        var prePath = "".concat(getDomain()).concat(pathPrefix);
        var cleanUrl = cleanUrlParams(prePath.replace('$[param]', getSlug()));
        return {
          rel: 'alternate',
          hreflang: id,
          href: cleanUrl
        };
      };
      for (var _i = 0, _Object$entries = Object.entries(data.value.slug); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          lang = _Object$entries$_i[0],
          slug = _Object$entries$_i[1];
        if (slug && acceptLanguage.includes(lang) && isSeoActivatedForLanguage(lang) && typeof slug === 'string' && !slug.startsWith(DUMBSLUG_PREFIX)) {
          metaData.link.push(metaConfig(lang, lang, slug));
          if (lang === defaultLocale) {
            metaData.link.push(metaConfig('x-default', lang, slug));
          }
        }
      }
    }
    if (hasSocialMeta()) {
      for (var _i2 = 0, _Object$values2 = Object.values(data.value.socialMeta); _i2 < _Object$values2.length; _i2++) {
        var _Object$values2$_i = _Object$values2[_i2],
          property = _Object$values2$_i.property,
          _content2 = _Object$values2$_i.content;
        metaData.meta.push({
          property: property,
          content: _content2
        });
      }
    }
    return metaData;
  };
  return {
    cleanUrlParams: cleanUrlParams,
    cleanQuery: cleanQuery,
    getOptionAttributeNamesFromFacets: getOptionAttributeNamesFromFacets,
    setMeta: setMeta,
    getMeta: getMeta,
    getPaginationMetaLinks: getPaginationMetaLinks,
    jsonld: computed(function () {
      var _data$value14;
      return (_data$value14 = data.value) === null || _data$value14 === void 0 ? void 0 : _data$value14.jsonld;
    })
  };
};
export default useLegacySeoMeta;